// Canal webchat: página pública em que o cliente final conversa pelo navegador.
export const WEBCHAT = "webchat";

export const isWebchat = (channel) => channel === WEBCHAT;

/** O webchat só responde a quem abriu a página: não serve para iniciar conversa nem para disparos. */
export const canStartConversations = (connection) => !isWebchat(connection?.channel);

export const filterOutboundConnections = (list) =>
  Array.isArray(list) ? list.filter(canStartConversations) : list;
